export default __webpack_public_path__ + "static/media/exit-gray.02a08df5.svg";